class StateSynchronizer {
    constructor(websocket, simulationId) {
        this.ws = websocket;
        this.simulationId = simulationId;
        this.pendingUpdates = new Map();
        this.syncInProgress = false;
        this.DEBOUNCE_MS = 100;

        this.init();
    }

    init() {
        this.syncTimer = null;
    }

    /**
     * Called when a local state change occurs (e.g. camera move)
     */
    onLocalStateChange(path, value) {
        // Essential check: Do we have control?
        // If path is camera, check camera lock
        if (path.startsWith('camera') && window.lockManager) {
            if (!window.lockManager.myLocks.has('camera')) {
                // We don't have the lock, so we shouldn't be broadcasting
                // In fact, the controls should probably be disabled or reverted if we don't have lock
                // But for now, just don't broadcast.
                return;
            }
        }

        this.pendingUpdates.set(path, {
            value: value,
            timestamp: Date.now()
        });

        if (this.syncTimer) {
            clearTimeout(this.syncTimer);
        }

        this.syncTimer = setTimeout(() => {
            this.syncPendingUpdates();
        }, this.DEBOUNCE_MS);
    }

    syncPendingUpdates() {
        if (this.pendingUpdates.size === 0 || this.ws.readyState !== WebSocket.OPEN) {
            return;
        }

        const updates = [];
        this.pendingUpdates.forEach((update, path) => {
            updates.push({
                path: path,
                value: update.value,
                timestamp: update.timestamp
            });
        });

        this.ws.send(JSON.stringify({
            type: 'state_update',
            updates: updates
        }));

        this.pendingUpdates.clear();
    }

    onRemoteStateUpdate(updates) {
        updates.forEach(update => {
            this.applyStateUpdate(update.path, update.value);
        });
    }

    applyStateUpdate(path, value) {
        const pathParts = path.split('.');

        if (pathParts[0] === 'camera') {
            this.applyCameraUpdate(pathParts.slice(1), value);
        } else if (pathParts[0] === 'filters') {
            this.applyFilterUpdate(pathParts.slice(1), value);
        }
    }

    applyCameraUpdate(parts, value) {
        // Ensure viewer and controls are fully initialized
        if (!window.viewer || !window.viewer.controls || !window.viewer.controls.object) {
            console.log('Camera controls not ready yet, skipping update');
            return;
        }

        // If we are currently interacting, maybe don't apply?
        // Or if we don't have lock, we should accept updates.
        // If we have lock, we shouldn't be receiving updates (others shouldn't send).

        try {
            if (parts[0] === 'position' && value) {
                window.viewer.controls.object.position.set(value.x, value.y, value.z);
            } else if (parts[0] === 'target' && value && window.viewer.controls.target) {
                window.viewer.controls.target.set(value.x, value.y, value.z);
            }

            window.viewer.controls.update();
        } catch (e) {
            console.warn('Failed to apply camera update:', e);
        }
    }

    applyFilterUpdate(parts, value) {
        // Implement filter sync
        // e.g. dispatch events to UI
        console.log("Remote filter update:", parts, value);
    }
}
